export class Ajax {

    static init() {
        Ajax.liveSearch();
    }

    static liveSearch() {
        var $ = jQuery;
        var $result = $('.js-search-result');
        var search_text = $('.js-search-text');
        //
        $(document.body).on('click', '.js-search', function () {
            $.ajax({
                url: vosveteit.ajax_url,
                data: {
                    action: 'vit_ajax_search',
                    query: search_text.val()
                },
                complete: function (xhr) {
                    var data = JSON.parse(xhr.responseText);
                    //
                    $result.html(data.html);
                },
                error: function (xhr) {
                    //
                }
            });
        });
    }
}